import "../styles/main.scss";

import { Core } from "@unseenco/taxi";
import RendererDefault from "./modules/transitions/renderers.js";
import TransitionDefault from "./modules/transitions/transitions.js";

export const taxi = new Core({
	renderers: {
		default: RendererDefault,
	},
	transitions: {
		default: TransitionDefault,
	},
});
